import { HEX } from "../../../src/actions/hex-patterns";
import {
  SCALING,
  SPICE_MAGIC
} from "../../../src/actions/scaling-presets";
import { Targeting } from "../../../src/actions/targeting";
import { SF_ } from "../../../src/actions/scaling";
import { MS, SEC } from "../../../src/time-utils";
const axe_swipe = {
  slug: "axe_swipe",
  name: "Axe Swing",
  abilityIcon: "axe_swipe",
  description: "A powerful swing with the battleaxe",
  tags: ["melee"],
  targeting: Targeting.MeleeAttack,
  cooldown: 0,
  windup: MS(500),
  costs: [{ stat: "energy", value: 1 }],
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.ARC_3,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: SCALING.KEEN_SLASHING
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  }
};
const axe_cleave = {
  slug: "axe_cleave",
  name: "Cleave",
  abilityIcon: "axe_cleave",
  costs: [{ stat: "energy", value: 5 }],
  targeting: Targeting.MeleeAttack,
  cooldown: 0,
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.ARC_3,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                physical: {
                  type: "chance",
                  min: SF_(0.3),
                  max: SF_(0.5),
                  qualityScaling: SF_(0.5),
                  // weapon matters a LOT
                  rating: 1
                },
                green: SPICE_MAGIC
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: []
};
const flame_cleave = {
  slug: "flame_cleave",
  name: "Flame Cleave",
  abilityIcon: "flame_cleave",
  description: "A wide fiery arc that scorches all in its path",
  costs: [{ stat: "energy", value: 8 }],
  targeting: Targeting.MeleeAttack,
  cooldown: SEC(4),
  windup: MS(500),
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.ARC_3,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                ...SCALING.KEEN_SLASHING,
                red: SPICE_MAGIC
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "melee", "aoe", "red"]
};
const tree_chop = {
  slug: "tree_chop",
  name: "Tree Chop",
  abilityIcon: "tree_chop",
  description: "A sweeping nature-imbued strike that tears through a wide arc",
  costs: [{ stat: "energy", value: 8 }],
  targeting: Targeting.MeleeAttack,
  cooldown: SEC(4),
  windup: MS(500),
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.ARC_3,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                ...SCALING.SLASHING,
                green: SPICE_MAGIC
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "melee", "aoe", "green"]
};
const shadow_cleave = {
  slug: "shadow_cleave",
  name: "Shadow Cleave",
  abilityIcon: "shadow_cleave",
  description: "A wide arc of shadow energy that tears through defenses",
  costs: [{ stat: "energy", value: 8 }],
  targeting: Targeting.MeleeAttack,
  cooldown: SEC(4),
  windup: MS(500),
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.ARC_3,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                ...SCALING.KEEN_SLASHING,
                black: SPICE_MAGIC
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "melee", "aoe", "black"]
};
const volt_cleave = {
  slug: "volt_cleave",
  name: "Volt Cleave",
  abilityIcon: "volt_cleave",
  description: "A sweeping arc of icy force that chills all it touches",
  costs: [{ stat: "energy", value: 8 }],
  targeting: Targeting.MeleeAttack,
  cooldown: SEC(4),
  windup: MS(500),
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.ARC_3,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                ...SCALING.KEEN_SLASHING,
                blue: SPICE_MAGIC
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "melee", "aoe", "blue"]
};
const radiant_cleave = {
  slug: "radiant_cleave",
  name: "Radiant Cleave",
  abilityIcon: "radiant_cleave",
  description: "A blazing arc of holy light that sears all in its path",
  costs: [{ stat: "energy", value: 8 }],
  targeting: Targeting.MeleeAttack,
  cooldown: SEC(4),
  windup: MS(500),
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.ARC_3,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                ...SCALING.KEEN_SLASHING,
                gold: SPICE_MAGIC
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "melee", "aoe", "gold"]
};
export {
  axe_cleave,
  axe_swipe,
  flame_cleave,
  radiant_cleave,
  shadow_cleave,
  tree_chop,
  volt_cleave
};
//# sourceMappingURL=data:application/json;base64,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
